import { Divider, Select, Typography } from 'antd';
import { useEffect, useState } from 'react';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatToINR, getMonthlyDebitCredit } from '../../../../Utils/utils';

const AccountsSummary: React.FC<{ selectedAccounts: any }> = ({
  selectedAccounts,
}) => {
  const [data, setData] = useState(getMonthlyDebitCredit(selectedAccounts));
  const [selectedMonth, setSelectedMonth] = useState(data.slice(-1)[0].value);
  const [creditAmount, setCreditAmount] = useState('');
  const [debitAmount, setDebitAmount] = useState('');
  const [creditTxn, setCreditTxn] = useState('');
  const [debitTxn, setDebitTxn] = useState('');

  useEffect(() => {
    setData(getMonthlyDebitCredit(selectedAccounts));
  }, [selectedAccounts]);

  useEffect(() => {
    if (selectedMonth !== '') {
      const filterData = data.filter((d: any) => {
        return d.value === selectedMonth;
      });

      setCreditAmount(filterData[0].Inflow);
      setDebitAmount(filterData[0].Outflow);
      setCreditTxn(filterData[0].totalCreditTxn);
      setDebitTxn(filterData[0].totalDebitTxn);
    }
  }, [selectedMonth, data]);

  const handleChange = (e: any) => {
    setSelectedMonth(e);
  };

  return (
    <>
      <div style={{ height: '15px' }}></div>
      <Select
        value={selectedMonth}
        className='selectionAccounts'
        style={{ width: '100%', height: 50, borderRadius: 50, fontWeight: 600 }}
        onChange={handleChange}
        id='selectionAccounts'
        title='Select Month'
        options={data
          .slice()
          .reverse()
          .map((d: any) => {
            return { value: d.value, label: d.label };
          })}
      />

      <div
        style={{
          background: 'white',
          borderRadius: 6,
          marginTop: 10,
          padding: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '45%',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: '12px',
                  }}
                >
                  Inflow
                </Typography.Text>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M19.0711 4.92895C19.4616 5.31947 19.4616 5.95264 19.0711 6.34316L8.05026 17.364H14.1213C14.6736 17.364 15.1213 17.8117 15.1213 18.364C15.1213 18.9163 14.6736 19.364 14.1213 19.364H5.63605C5.08376 19.364 4.63605 18.9163 4.63605 18.364V9.87869C4.63605 9.32641 5.08376 8.87869 5.63605 8.87869C6.18833 8.87869 6.63605 9.32641 6.63605 9.87869V15.9498L17.6569 4.92895C18.0474 4.53842 18.6806 4.53842 19.0711 4.92895Z'
                    fill='green'
                  />
                </svg>
              </div>

              <Typography.Text
                style={{
                  fontSize: '20px',
                  fontWeight: '600',
                }}
              >
                {formatToINR(creditAmount)}
              </Typography.Text>

              <Typography.Text
                style={{
                  fontSize: '10px',
                }}
              >
                {creditTxn} transactions
              </Typography.Text>
            </div>
            {/* <svg
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929L12.5858 12L10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289Z'
                fill='rgba(189,189,189, 1)'
              />
            </svg> */}
          </div>
          <Divider type='vertical' />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '45%',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: '12px',
                  }}
                >
                  Outflow
                </Typography.Text>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M8.87867 5.63604C8.87867 5.08375 9.32639 4.63604 9.87867 4.63604H18.364C18.9162 4.63604 19.364 5.08375 19.364 5.63604V14.1213C19.364 14.6736 18.9162 15.1213 18.364 15.1213C17.8117 15.1213 17.364 14.6736 17.364 14.1213V8.05025L6.34314 19.0711C5.95261 19.4616 5.31945 19.4616 4.92893 19.0711C4.5384 18.6805 4.5384 18.0474 4.92893 17.6569L15.9497 6.63604H9.87867C9.32639 6.63604 8.87867 6.18832 8.87867 5.63604Z'
                    fill='red'
                  />
                </svg>
              </div>
              <Typography.Text
                style={{
                  fontSize: '20px',
                  fontWeight: '600',
                }}
              >
                {formatToINR(debitAmount)}
              </Typography.Text>
              <Typography.Text
                style={{
                  fontSize: '10px',
                }}
              >
                {debitTxn} transactions
              </Typography.Text>
            </div>
          </div>
        </div>
        <div style={{ height: '15px' }}></div>
        <ResponsiveContainer width={'100%'} height={300}>
          <BarChart data={data.slice(-6)} className='barChart'>
            <XAxis dataKey='name' />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey='Inflow' fill='#5BB458' minPointSize={5} />
            <Bar dataKey='Outflow' fill='#ff4122  ' minPointSize={10} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default AccountsSummary;
